export function convertCSSTime (time) {
  let transitionDuration = time.split('s')[0]
  return parseFloat(transitionDuration) * 1000
}

export function getTrasitionDuration (elem) {
  let transitionDuration = window.getComputedStyle(elem).transitionDuration
  let transitionDelay = window.getComputedStyle(elem).transitionDelay
  return convertCSSTime(transitionDuration) + convertCSSTime(transitionDelay)
}

export function getAnimationDuration (elem) {
  let animationDuration = window.getComputedStyle(elem).animationDuration
  let animationDelay = window.getComputedStyle(elem).animationDelay
  return convertCSSTime(animationDuration) + convertCSSTime(animationDelay)
}
